import { Text } from '@wix/design-system';
import React, { useContext } from 'react';

import { RicosContext } from './../../../ricos-context';

export const Disclaimer: React.FC = () => {
  const { t } = useContext(RicosContext);
  return (
    <Text size="tiny" skin="disabled">
      {t('AIPlugin_ResultsDisclaimer_Text')}
    </Text>
  );
};
